export default __webpack_public_path__ + "static/media/logo-horizontal.93bce83d.png";